import Vue from 'vue';
import Vuex from 'vuex';
import unit from "@/store/unit";
import user from "@/store/user";
import property from "@/store/property";
import authentication from "@/store/authenication";
import localeStore from "@/store/localeStore";

Vue.use(Vuex);


export default new Vuex.Store({

    modules: {
        portal: authentication,
        property: property,
        unit: unit,
        user: user,
        localeStore: localeStore
    }
});

